export function navigationInit() {
    let menuButton = document.querySelector('.menuButton');
    let open = document.querySelector('.openMenu');
    let close = document.querySelector('.closeMenu');
    let header = document.querySelector('.header');
    let nav = document.querySelector('.header__content__nav');
    let body = document.querySelector('body');

    !nav ? nav = document.querySelector('.header__content__nav') : null;

    menuButton.addEventListener('click', () => {
        header.classList.toggle("header--active");
        nav.classList.toggle("header__content__nav--active");

        if (nav.classList.contains('header__content__nav--active')) {
            open.style.display = 'none';
            close.style.display = 'block';
            body.style.overflowY = 'hidden';
        }else{
            open.style.display = 'block';
            close.style.display = 'none';
            body.style.overflowY = 'auto';
        }
    })
}